import TEXT, { HTMLELEMENT } from '../../DOM/text/TEXT.js';
import EL from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const headingAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['style']
]);
export const headingData = makeDataStruct([
    ['depth', 1],
    ['text', ''],
    ['textGroup', ''],
    ['textKey', '']
]);
export const headingModel = makeStruct([
    ['attributes', headingAttr],
    ['data', headingData]
]);
// Simplified Model
export function heading(depth = 1, text = '', className, textGroup, textKey) {
    return {
        attributes: headingAttr(className),
        data: headingData(depth, text, textGroup, textKey)
    };
}
/** A generic heading element */
export default class HEADING extends TEXT {
    constructor(node, model) {
        super(node, model.data.depth
            ? HTMLELEMENT['H' + model.data.depth]
            : HTMLELEMENT.H1, model);
    }
}
export { EL, HTMLELEMENT };
